import { createStore } from 'satcheljs';
import { ObservableMap } from 'owa-mobx4-adapter';
// Import mutators so they are initialized at the same time as the store
import '../mutators/updateFolderCountsMutator';
var initialFolderTreeViewStateStore = {
    folderNodeViewStates: new ObservableMap({}),
    contextMenuState: null,
    folderTextFieldViewState: null,
    isDraggedOver: false,
    withContextMenuFolderId: null,
};
var store = createStore('folderViewState', initialFolderTreeViewStateStore)();
export default store;
//# sourceMappingURL=store.js.map